module.exports = __webpack_public_path__ + "static/media/CM-marca_preferencial-negativa-RGB.a537be02.svg";